import { render, staticRenderFns } from "./policy-details.vue?vue&type=template&id=39f08f0f"
import script from "./policy-details.vue?vue&type=script&lang=js"
export * from "./policy-details.vue?vue&type=script&lang=js"
import style0 from "./policy-details.vue?vue&type=style&index=0&id=39f08f0f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f08f0f')) {
      api.createRecord('39f08f0f', component.options)
    } else {
      api.reload('39f08f0f', component.options)
    }
    module.hot.accept("./policy-details.vue?vue&type=template&id=39f08f0f", function () {
      api.rerender('39f08f0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/policy-set/policy-details.vue"
export default component.exports